/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListCategoryResponseDto } from '../../models/sales-price-list-category-response-dto';
import { SalesPriceListCategoryUpdateDto } from '../../models/sales-price-list-category-update-dto';

export interface PriceListCategoriesControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the price list category to update.
 */
  id: string;
      body: SalesPriceListCategoryUpdateDto
}

export function priceListCategoriesControllerUpdate(http: HttpClient, rootUrl: string, params: PriceListCategoriesControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListCategoriesControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>;
    })
  );
}

priceListCategoriesControllerUpdate.PATH = '/o2-sales/price-list-categories/{tenant}/{id}';
